import { useEffect } from 'react';
import { useCallback } from 'react';
import { updateGTMCodeContext, useUiValue } from 'stores/uiContext';

const useGTMFunction = () => {
  const [{ gtmCode }, dispatch] = useUiValue();

  useEffect(() => {
    dispatch(updateGTMCodeContext(gtmCode));
  }, []);

  const updateGTMCodeFunction = useCallback(
    (code) => {
      dispatch(updateGTMCodeContext(code));
    },
    [gtmCode],
  );

  return {
    gtmCode,
    updateGTMCodeFunction,
  };
};
export default useGTMFunction;
